import { render, staticRenderFns } from "./GlobalIndicatorsEmploymentProfile.vue?vue&type=template&id=12481995&"
import script from "./GlobalIndicatorsEmploymentProfile.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsEmploymentProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports